module.exports = __webpack_public_path__ + "img/logo_1.e6051e12.svg";